import { hexToBin } from '../../../format/format.js';
import { encodeTransactionCommon, hashTransactionP2pOrder, } from '../../../message/message.js';
export var ConsensusXec;
(function (ConsensusXec) {
    /**
     * A.K.A. `MAX_SCRIPT_ELEMENT_SIZE`
     */
    ConsensusXec[ConsensusXec["maximumStackItemLength"] = 520] = "maximumStackItemLength";
    ConsensusXec[ConsensusXec["maximumVmNumberLength"] = 4] = "maximumVmNumberLength";
    /**
     * A.K.A. `MAX_OPS_PER_SCRIPT`
     */
    ConsensusXec[ConsensusXec["maximumOperationCount"] = 201] = "maximumOperationCount";
    /**
     * A.K.A. `MAX_SCRIPT_SIZE`
     */
    ConsensusXec[ConsensusXec["maximumBytecodeLength"] = 10000] = "maximumBytecodeLength";
    /**
     * A.K.A. `MAX_STACK_SIZE`
     */
    ConsensusXec[ConsensusXec["maximumStackDepth"] = 1000] = "maximumStackDepth";
    ConsensusXec[ConsensusXec["schnorrSignatureLength"] = 64] = "schnorrSignatureLength";
})(ConsensusXec || (ConsensusXec = {}));
export const createTestAuthenticationProgramBch = ({ lockingBytecode, valueSatoshis, unlockingBytecode, }) => {
    const testFundingTransaction = {
        inputs: [
            {
                outpointIndex: 0xffffffff,
                outpointTransactionHash: hexToBin('0000000000000000000000000000000000000000000000000000000000000000'),
                sequenceNumber: 0xffffffff,
                unlockingBytecode: Uint8Array.of(0, 0),
            },
        ],
        locktime: 0,
        outputs: [{ lockingBytecode, valueSatoshis }],
        version: 1,
    };
    const testSpendingTransaction = {
        inputs: [
            {
                outpointIndex: 0,
                outpointTransactionHash: hashTransactionP2pOrder(encodeTransactionCommon(testFundingTransaction)),
                sequenceNumber: 0xffffffff,
                unlockingBytecode,
            },
        ],
        locktime: 0,
        outputs: [{ lockingBytecode: Uint8Array.of(), valueSatoshis }],
        version: 1,
    };
    return {
        inputIndex: 0,
        sourceOutputs: testFundingTransaction.outputs,
        transaction: testSpendingTransaction,
    };
};
//# sourceMappingURL=xec-types.js.map